import { render, staticRenderFns } from "./BatchDepartmentEdit.vue?vue&type=template&id=7f2c2c62"
import script from "./BatchDepartmentEdit.vue?vue&type=script&lang=ts"
export * from "./BatchDepartmentEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports